import { render, staticRenderFns } from "./CriterionRatingWithoutHeader.vue?vue&type=template&id=4dea5ee8&scoped=true&"
import script from "./CriterionRatingWithoutHeader.vue?vue&type=script&lang=js&"
export * from "./CriterionRatingWithoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./CriterionRatingWithoutHeader.vue?vue&type=style&index=0&id=4dea5ee8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dea5ee8",
  null
  
)

export default component.exports